import React from 'react'

/**
 * GTM Hidden Fields Component
 * Provides hidden input fields for GTM to scrape form values
 * Used across Success, Loading, and Fail components to ensure consistent availability
 */
export default function GTMHiddenFields({ data }) {

  // Ensure data exists to prevent errors
  if (!data) {
    return null
  }

  return (
    <>
      {/* Hidden fields for GTM to scrape form values */}
      <input
        key="gtm-eaters"
        type="hidden"
        data-test-id="eaters"
        defaultValue={data.eaters || 0}
        readOnly
      />
      
      {/* Conditional payer fields - only render if condition matches */}
      {data.payer === 'host' && (
        <>
          <input
            key="gtm-payer-host"
            type="hidden"
            data-test-id="payer-host"
            defaultValue="true"
            className="border-blue-300"
            readOnly
          />
        </>
      )}
      
      {data.payer === 'attendee' && (
        <>
          <input
            key="gtm-payer-attendee"
            type="hidden"
            data-test-id="payer-attendee"
            defaultValue="true"
            className="border-blue-300"
            readOnly
          />
        </>
      )}
      
      {/* One-time and recurring fields */}
      {data.payer === 'attendee' && !data.recurring && (
        <>
          <input
            key="gtm-one-time"
            type="hidden"
            data-test-id="one-time"
            defaultValue="true"
            className="border-blue-300"
            readOnly
          />
        </>
      )}
      
      {data.payer === 'attendee' && data.recurring && (
        <>
          <input
            key="gtm-recurring"
            type="hidden"
            data-test-id="recurring"
            defaultValue="true"
            className="border-blue-300"
            readOnly
          />
        </>
      )}
    </>
  )
}